import messageListLayoutStore from '../messageListLayoutStore';
import getFallbackPreviewLinesToShow from '../../utils/getFallbackPreviewLinesToShow';
import resolvePreviewLinesForDisplay from '../../utils/resolvePreviewLinesForDisplay';

export default function getShowPreviewLinesInListView(): number {
    const messagePreviewStore = messageListLayoutStore();
    const previewLines =
        messagePreviewStore.showPreviewLinesInListView ?? getFallbackPreviewLinesToShow();

    return resolvePreviewLinesForDisplay(previewLines);
}
